module.exports = __webpack_public_path__ + "static/media/logo-opmbr.8acabfc0.svg";